import { Grid } from '@mui/material';

import { RightPanelHeader } from '../../../../components/right-panel-info/RightPanel.styled';
import { Client } from '../../../../domain/client/Client';

type ClientHeaderProps = {
  client: Client;
  onClose: (...args: any[]) => any;
  options?: React.ReactElement | any;
};

export const ClientHeader = ({ client, options, onClose }: ClientHeaderProps) => {
  if (client) {
    return (
      <RightPanelHeader onClose={onClose}>
        <Grid container wrap="nowrap">
          <Grid
            item
            container
            justifyContent="flex-start"
            style={{ width: `100%` }}
            wrap="nowrap"
            alignItems="center"
          />

          <Grid container direction="row" style={{ width: `auto` }} wrap="nowrap" alignItems="center">
            {options}
          </Grid>
        </Grid>
      </RightPanelHeader>
    );
  }
  return null;
};
